import consumer from "./consumer"

consumer.subscriptions.create("FilmtecDashboardChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
    console.log("Connected to the Filmtec Dashboard!");
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    // R1 Status
    $('#robot_home_flmtc').text(data.log.robot_home == true ? "HOME" : "IN JOB");
    $('#robot_fault_flmtc').text(data.log.robot_fault == true ? "FAULT" : "NO FAULT");
    if (data.log.cell_manual == true) {
      $('#cell_manual_flmtc').removeClass('blue');
      $('#cell_manual_flmtc').addClass('green');
    } else {
      $('#cell_manual_flmtc').removeClass('green');
      $('#cell_manual_flmtc').addClass('blue');
    }
    if (data.log.cell_auto == true) {
      $('#cell_auto_flmtc').removeClass('blue');
      $('#cell_auto_flmtc').addClass('green');
    } else {
      $('#cell_auto_flmtc').removeClass('green');
      $('#cell_auto_flmtc').addClass('blue');
    }
    // Production
    $('#ok_part_flmtc').text(data.log.ok_part);
    $('#rejected_part_flmtc').text(data.log.rejected_part);
    $('#total_count_flmtc').text(data.log.total_count);
    // Part Details
    $('#part_diameter_flmtc').text(data.log.part_diameter);
    $('#part_weight_flmtc').text(data.log.part_weight);
    // Patterns
    if (data.log.pattern_01 == true) {
      $('#pattern_1').removeClass('blue');
      $('#pattern_1').addClass('green');
    } else {
      $('#pattern_1').removeClass('green');
      $('#pattern_1').addClass('blue');
    }
    if (data.log.pattern_02 == true) {
      $('#pattern_2').removeClass('blue');
      $('#pattern_2').addClass('green');
    } else {
      $('#pattern_2').removeClass('green');
      $('#pattern_2').addClass('blue');
    }
    if (data.log.pattern_03 == true) {
      $('#pattern_3').removeClass('blue');
      $('#pattern_3').addClass('green');
    } else {
      $('#pattern_3').removeClass('green');
      $('#pattern_3').addClass('blue');
    }
  }
});
